module.exports = __webpack_public_path__ + "img/901162286.0cffae61.png";